module.exports = __webpack_public_path__ + "static/media/pusins_delama_tonelli.2504b829.gif";